export default {
      id: "getSnapshot-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#getSnapshot",
      toString: function () {
        return this.url;
      }
    }